import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const getJobServiceSelection = async ({ queryKey }: JsonDataItem) => {
  const { data } = await baseQuery(`service-service-selection/${queryKey[1]}`);

  return data;
};
